import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Container, Dimmer, Loader } from 'semantic-ui-react';
import { auth } from '../index';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import Home from './Home';
import Customers from './customers/Customers';
import CustomerTable from './customers/CustomerTable';
import Jobs from './jobs/Jobs';
import JobTable from './jobs/JobTable';
import Materials from './materials/Materials';
import MaterialTable from './materials/MaterialTable';
import StandardOperations from './standard-operations/StandardOperations';
import StandardOperationTable from './standard-operations/StandardOperationTable';
import SplashScreen from './SplashScreen';
import SignInForm from './SignInForm';

class App extends Component {
  state = {
    isWaitingForAuth: true,
    authUser: null
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      this.setState({ isWaitingForAuth: false, authUser: user })
      this.props.store.load(user)
    })
  }

  render() { 
    const { isWaitingForAuth, authUser } = this.state
    const { isLoading } = this.props.store
    if (isWaitingForAuth) return <SplashScreen />
    if (!authUser) return <SignInForm />
    return (
      <Router>
        <div style={{ height: '100%', display: 'flex', flexFlow: 'column' }}>
          <AppHeader />
          {isLoading ? (
            <Dimmer active><Loader>Loading data...</Loader></Dimmer>
          ) : (
            <Container style={{ flex: 1, display: 'flex', flexFlow: 'column' }}>
              <Route exact path='/' component={Home} />
              <Route path='/customers' render={() => <Customers ListComponent={CustomerTable} />} />
              <Route path='/products' render={() => <Jobs ListComponent={JobTable} />} />
              <Route path='/materials' render={() => <Materials ListComponent={MaterialTable} />} />
              <Route path='/standardOperations' render={() => <StandardOperations ListComponent={StandardOperationTable} />} />
            </Container>
          )}
          <AppFooter />
        </div>
      </Router>
    )
  }
}
 
export default inject('store')(observer(App));


// WEBPACK FOOTER //
// ./src/components/App.js